import { readonly, ref } from "vue";
export const ZOOM_LEVELS = [
    { label: "60%", value: 0.6 },
    { label: "75%", value: 0.75 },
    { label: "90%", value: 0.9 },
    { label: "100%", value: 1 },
];
export const DEFAULT_ZOOM = 0.75;
// Module-level singleton — shared across all importers within the SPA session.
// Recreated on every full page (re)load, so the default re-applies automatically
// without any localStorage persistence.
const zoom = ref(DEFAULT_ZOOM);
export function useTableZoom() {
    function setZoom(value) {
        zoom.value = value;
    }
    return {
        tableZoom: readonly(zoom),
        setZoom,
        zoomLevels: ZOOM_LEVELS,
    };
}
